/**
 * Danh sách toàn bộ Route của ứng dụng.
 * Giúp quản lý việc điều hướng tập trung, tránh lỗi typo chuỗi.
 */
export const APP_ROUTES = {
  LOGIN: 'login',
  DASHBOARD: 'dashboard',
  FORBIDDEN: '403',
  SETTINGS: 'settings',
  PERMISSION_GROUPS: 'permission-groups',
  WAREHOUSE: 'warehouses',
  HISTORY_WAREHOUSE: 'warehouses-history',
  WAREHOUSE_REPORT: 'warehouse-report',
  PLATFORM_FEE: 'platform-fees',
  SERVICE: 'services',
  EMPLOYEES: 'employees',
  PERMISSIONS: 'permissions',
  FORGOT_PASSWORD: 'forgot-password',
  ACTIVITY_LOG: 'activity-log',
  KPI_CAMERA: 'kpi-camera',
  DEVICE_TYPE: 'device-types',
  DEVICE: 'devices',
  SIM: 'sim-cards',
  USERS: 'users',
  API_SETTINGS: 'api-settings',
  ROOT: '',
} as const;
